// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subaccounts_GatewayTestTriggerResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subaccounts_GatewayTestTriggerResponse — `dados` for
 * POST /subaccounts/webhooks/gatewaytest-staff (S3b).
 *
 * The staff trigger takes the SAME body as the raw webhook
 * (Subaccounts_GatewayTestTriggerInput — reused, not duplicated), signs it
 * server-side with the stored gatewaytest webhook_secret, and re-enters the
 * identical verify -> normalize -> dispatch path. This contract reports what
 * that dispatch did, so the dev panel does not have to guess from a bare 200.
 *
 * Shape:
 * {
 *   "provider_code":     "gatewaytest",
 *   "event_type":        "PAYMENT_CONFIRMED",
 *   "provider_event_id": "gatewaytest-evt-PAYMENT_CONFIRMED-68a1...",
 *   "webhook_id":        1234,
 *   "message":           "subscription_processed",
 *   "reason":            null
 * }
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subaccounts_GatewayTestTriggerResponseDados {
provider_code: string
event_type: string
provider_event_id: string
message: string
webhook_id?: number
reason?: string
}

export type Subaccounts_GatewayTestTriggerResponse = ApiResponse<Subaccounts_GatewayTestTriggerResponseDados>;

registerResponseContract('Subaccounts_GatewayTestTriggerResponse', {
  provider_code:     { type: 'string',  required: true },
  event_type:        { type: 'string',  required: true },
  provider_event_id: { type: 'string',  required: true },
  message:           { type: 'string',  required: true },
  webhook_id:        { type: 'number',  required: false },
  reason:            { type: 'string',  required: false },
})
